import { Guid, Nillable } from '@web/utils';
import { Multimedia } from '@web/shared/module/multimedia';
import { WarehouseReleaseStatus } from '../enums/warehouse-release-status';
import { WarehouseReleaseProduct } from './warehouse-release-product';

export class WarehouseReleaseDetails {
  public constructor(
    private readonly data: {
      canBeApproved: boolean;
      canBeEdited: boolean;
      canBeViewed: boolean;
      comment?: Nillable<string>;
      createdAt: Date;
      approvedAt?: Nillable<Date>;
      id: Guid;
      number: string;
      releasedAt: Date;
      status: WarehouseReleaseStatus;
      files: Multimedia[];
      products: WarehouseReleaseProduct[];
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get comment(): Nillable<string> {
    return this.data.comment;
  }

  public get createdAt(): Date {
    return this.data.createdAt;
  }

  public get canBeEdited(): boolean {
    return this.data.canBeEdited;
  }

  public get canBeViewed(): boolean {
    return this.data.canBeViewed;
  }

  public get canBeApproved(): boolean {
    return this.data.canBeApproved;
  }

  public get number(): string {
    return this.data.number;
  }

  public get releasedAt(): Date {
    return this.data.releasedAt;
  }

  public get approvedAt(): Nillable<Date> {
    return this.data.approvedAt;
  }

  public get status(): WarehouseReleaseStatus {
    return this.data.status;
  }

  public get files(): Nillable<Multimedia[]> {
    return this.data.files;
  }

  public get products(): Nillable<WarehouseReleaseProduct[]> {
    return this.data.products;
  }
}
